export { default } from './StoryImage';
